import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { BRAND } from "../config/brand";
import { Lock, CheckCircle } from "@phosphor-icons/react";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const nav = useNavigate();
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    if (!token) {
        return (
            <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-50">
                <div className="w-full max-w-md bg-white border border-zinc-200 p-10 text-center">
                    <div className="overline mb-2 text-red-600">Link non valido</div>
                    <h1 className="text-2xl font-black tracking-tighter mb-4">Token mancante</h1>
                    <p className="text-sm text-zinc-600 mb-6">
                        Il link che hai aperto non contiene un token di reset valido.
                    </p>
                    <Link to="/forgot-password" className="btn-primary inline-flex items-center justify-center">
                        Richiedi nuovo link
                    </Link>
                </div>
            </div>
        );
    }

    const submit = async (e) => {
        e.preventDefault();
        if (pw.length < 6) {
            toast.error("La password deve essere di almeno 6 caratteri");
            return;
        }
        if (pw !== pw2) {
            toast.error("Le due password non coincidono");
            return;
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            setDone(true);
            toast.success("Password aggiornata");
            setTimeout(() => nav("/login"), 1500);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Errore nel reset");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-50">
            <div className="w-full max-w-md bg-white border border-zinc-200">
                <div className="h-1 bg-signal" />
                <div className="p-10">
                    <div className="overline mb-2">{BRAND.name}</div>
                    <h1 className="text-3xl font-black tracking-tighter mb-2">
                        Nuova password
                    </h1>
                    <p className="text-sm text-zinc-600 mb-8 leading-relaxed">
                        Imposta la nuova password per il tuo account. Il link scade dopo 1 ora dall'invio.
                    </p>

                    {done ? (
                        <div className="text-center py-6" data-testid="reset-done">
                            <CheckCircle size={48} weight="bold" className="mx-auto mb-4 text-green-600" />
                            <p className="text-sm text-zinc-700">
                                Password aggiornata. Reindirizzamento al login…
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={submit}>
                            <label className="block mb-4">
                                <div className="overline mb-2">Nuova password</div>
                                <input
                                    type="password"
                                    className="inp"
                                    value={pw}
                                    onChange={(e) => setPw(e.target.value)}
                                    required
                                    minLength={6}
                                    autoFocus
                                    autoComplete="new-password"
                                    data-testid="reset-pw-input"
                                />
                                <div className="text-xs text-zinc-500 mt-1">Min 6 caratteri</div>
                            </label>
                            <label className="block mb-6">
                                <div className="overline mb-2">Conferma password</div>
                                <input
                                    type="password"
                                    className="inp"
                                    value={pw2}
                                    onChange={(e) => setPw2(e.target.value)}
                                    required
                                    minLength={6}
                                    autoComplete="new-password"
                                    data-testid="reset-pw2-input"
                                />
                            </label>
                            <button
                                type="submit"
                                disabled={loading}
                                className="btn-primary w-full inline-flex items-center justify-center gap-2"
                                data-testid="reset-submit-button"
                            >
                                <Lock size={14} weight="bold" />
                                {loading ? "Aggiornamento…" : "Imposta password"}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
